module.exports = __webpack_public_path__ + "static/img/IMG_9127.bf7d83e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IMG_9127.jpg
// module id = 310
// module chunks = 2